var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwimmingPoolIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.01393L6.5 2.00391C5.39 2.00391 4.5 2.89561 4.5 4.00774V20.0384C4.5 21.1505 5.39 22.0423 6.5 22.0423H18.5C19.61 22.0423 20.5 21.1505 20.5 20.0384V4.00774C20.5 2.89561 19.61 2.01393 18.5 2.01393ZM18.5 20.0384H6.5L6.49 4.00774H18.5V20.0384Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.0136C9.05228 7.0136 9.5 6.56503 9.5 6.01168C9.5 5.45834 9.05228 5.00977 8.5 5.00977C7.94772 5.00977 7.5 5.45834 7.5 6.01168C7.5 6.56503 7.94772 7.0136 8.5 7.0136Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.0136C12.0523 7.0136 12.5 6.56503 12.5 6.01168C12.5 5.45834 12.0523 5.00977 11.5 5.00977C10.9477 5.00977 10.5 5.45834 10.5 6.01168C10.5 6.56503 10.9477 7.0136 11.5 7.0136Z",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.0368C15.26 19.0368 17.5 16.7925 17.5 14.0272C17.5 11.2619 15.26 9.01758 12.5 9.01758C9.74 9.01758 7.5 11.2619 7.5 14.0272C7.5 16.7925 9.74 19.0368 12.5 19.0368ZM14.86 11.6626C16.16 12.9651 16.16 15.0892 14.86 16.3917C13.56 17.6942 11.44 17.6942 10.14 16.3917L14.86 11.6626Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingPoolIcon);
export default __webpack_public_path__ + "static/media/SwimmingPoolIcon.b6230a7f831cd316cbb1bdfe1952509a.svg";
export { ForwardRef as ReactComponent };